import * as React from 'react';
import tinycolor from 'tinycolor2';
import styled from 'styled-components';
import { Hue as HueBase } from 'react-color/lib/components/common';

import { CustomPointer } from '@process-advisor/process-miner/components/colorPicker/customPointer';

const HueContainer = styled.div`
    height: 10px;
    width: 100%;
    border-radius: 5px;
    position: relative;
`;

type Props = {
    activeColor: string;
    onColorChange: (color: string) => void;
};

export const Hue: React.FC<Props> = ({ activeColor, onColorChange }) => (
    <HueContainer>
        <HueBase
            hsl={tinycolor(activeColor).toHsl()}
            onChange={({ h, s, l, a }) => {
                const color = a === 1
                    ? tinycolor({ h, s, l }).toHexString()
                    : tinycolor({ h, s, l, a }).toHex8String();
                onColorChange(color);
            }}
            pointer={CustomPointer}
            color={activeColor} />
    </HueContainer>
);
